import React, { useState } from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { Points, textSize } from '@styles';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { PageTop, Container, SearchField } from '@components/Help-Center-Components';
import { HELP_CENTER } from '@constants';

export const TroublesSection = ({ data }) => {
  const translations = useTranslations();
  const [isSearchActive, setIsSearchActive] = useState(false);
  const links = [
    {
      href: `/${HELP_CENTER.MAIN}`,
      name: translations.t('site.help.title'),
    },
    {
      href: '',
      name: `${data.caption}`,
    },
  ];

  return (
    <Wrapper>
      {!isSearchActive && <Breadcrumbs links={links} />}
      <Container>
      {!isSearchActive && (<PageTop title={data.caption} description={data.description} />)}
        <SearchField isSearchActive={isSearchActive} searchActiveHandle={(isActive) => setIsSearchActive(isActive)} selectedSection={HELP_CENTER.TROUBLES} />
        {!isSearchActive && (
          <ContentWrapper>
            {data.categories.map((category) => (
              <Category key={category.slug}>
                <CategoryTitle>{category.caption}</CategoryTitle>
                <CategoryList>
                  {data.items
                    .filter((item) => item.category === category.slug)
                    .map((item) => (
                      <CategoryItem key={item.slug}>
                        <Link
                          href={`/${HELP_CENTER.MAIN}/${HELP_CENTER.TROUBLES}/${item.category}/${item.slug}`}
                          passHref>
                          <CategoryLink>{item.caption}</CategoryLink>
                        </Link>
                      </CategoryItem>
                    ))}
                </CategoryList>
              </Category>
            ))}
          </ContentWrapper>
        )}
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 55px 16px 0;
  max-width: 1386px;
  min-height: 100vh;

  @media ${Points.tablet_landscape} {
    margin: 30px 28px 0;
  }

  @media ${Points.laptop_wide} {
    margin: 40px auto 0;
    padding: 0 80px;
  }

  @media ${Points.fullhd} {
    padding: 0;
  }
`;

const ContentWrapper = styled.div`
  margin-top: 60px;

  @media ${Points.tablet_landscape} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px 15px;
    margin-top: 70px;
  }

  @media ${Points.laptop_wide} {
    grid-template-columns: repeat(3, 1fr);
    gap: 40px 20px;
    margin-top: 80px;
  }

  @media ${Points.fullhd} {
    margin-top: 90px;
  }
`;

const Category = styled.div`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }

  @media ${Points.tablet_landscape} {
    margin-bottom: 0;
  }
`;

const CategoryTitle = styled.h2`
  ${textSize('body')}
  font-weight: 400;
  padding-bottom: 10px;
  border-bottom: 1px solid #e1e1e1;
  color: ${Colors.main_dark};
`;

const CategoryList = styled.ul`
  ${Mixins.resetList()};
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media ${Points.tablet_landscape} {
    margin-bottom: 0;
  }
`;

const CategoryItem = styled.li`
  ${textSize('description')};
`;

const CategoryLink = styled.a`
  ${Mixins.resetLink()};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: ${(p) => !p.isCurrent && Colors.second_blue};
    }
  }

  &:active {
    color: ${(p) => !p.isCurrent && Colors.main_blue};
  }
`;
